import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    DateField,
    Filter,
    downloadCSV,
    TextInput,
    SelectField,
    SelectInput,
    CardActions,
    BooleanField,
    ExportButton,
    BooleanInput
} from 'react-admin';
import jsonExport from 'jsonexport/dist';

const exporter = users => {
    const data = users.map(user => {
        user.NAME = user.fullName;
        user.GENDER = user.gender;
        user.MOBILE_NO = user.mobileNo;
        user.VERIFIED = user.enabled ? 'YES' : 'NO';
        user.REGISTRATION_TIME = new Date(user.creationTime);
        return user;
    })

    jsonExport(data, {
        headers: ['NAME', 'GENDER', 'MOBILE_NO', 'VERIFIED', 'REGISTRATION_TIME']
    }, (err, csv) => {
        downloadCSV(csv, `users_${new Date().getTime()}`);
    });
};

const registrationTypeChoices = [
    { id: 'GOOGLE', name: 'Google' },
    { id: 'ZADISH', name: 'Zadish' },
];

const UserFilter = (props) => (
    <Filter {...props}>
        <TextInput source="firstName" label="First Name" />
        <TextInput source="lastName" label="Last Name" />
        <TextInput source="mobileNo" label="Mobile No" />
        <TextInput source="appVersion" label="App Version" />
        <TextInput source="emailId" label="Email ID" />
        <BooleanInput source="enabled" label="Enabled" />
        <SelectInput source="registrationType" label="Registration Type" choices={registrationTypeChoices} />
    </Filter>
);

const UserActions = ({
    currentSort,
    displayedFilters,
    exporter,
    filters,
    filterValues,
    resource,
    showFilter
}) => (
    <CardActions>
        {filters && React.cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
        })}
        <ExportButton
            resource={resource}
            sort={currentSort}
            filter={filterValues}
            exporter={exporter}
            maxResults={10000}
        />
    </CardActions>
);

export const UserList = (props) => {
    const cityId = sessionStorage.getItem("cityId");
    const userType = atob(sessionStorage.getItem("zutp"));
    const dataFields = <Datagrid>
        <TextField source="fullName" label="Name" sortable={false} />
        <TextField source="emailId" label="Email" />
        <TextField source="mobileNo" label="Mobile" />
        <SelectField source="registrationType" label="Registration Type" choices={registrationTypeChoices} />
        <BooleanField source="enabled" label="Verified" />
        <TextField source="appVersion" label="App Version" />
        <DateField source="lastSeenTime" showTime label="Last Seen Time" />
        <DateField source="creationTime" showTime label="Creation Time" />
    </Datagrid>;
    if (userType === "SA") {
        return (
            <List {...props} title="App Users" bulkActionButtons={false} exporter={exporter}
                sort={{ field: "creationTime", order: "DESC" }} filters={<UserFilter />} actions={<UserActions />}>
                {dataFields}
            </List>
        );
    } else {
        return (
            <List {...props} title="App Users" bulkActionButtons={false} exporter={exporter}
                sort={{ field: "creationTime", order: "DESC" }} filters={<UserFilter />} actions={<UserActions />}
                filter={{ userCityId: cityId }}>
                {dataFields}
            </List>
        );
    }
};

